// Search input + recursive tree rendering. The detail panel and the page
// header consume the same `cats` so filtering happens here, in one place.

import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { filterTree, type Category } from "./types";
import { CategoryTreeNode } from "./category-tree-node";

interface Props {
  cats: Category[];
  query: string;
  onQueryChange: (q: string) => void;
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function CategoryTree({ cats, query, onQueryChange, selectedId, onSelect }: Props) {
  const visible = filterTree(cats, query);
  const hasQuery = query.trim().length > 0;

  return (
    <div className="flex h-full flex-col">
      <div className="relative shrink-0 px-3 pb-2">
        <Search
          size={14}
          className="pointer-events-none absolute left-6 top-1/2 -translate-y-1/2 text-muted-foreground"
        />
        <Input
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Tìm danh mục…"
          className="h-9 pl-8"
          aria-label="Tìm danh mục"
        />
      </div>

      <div className="flex-1 overflow-y-auto px-1 pb-2">
        {visible.length === 0 ? (
          <p className="px-3 py-6 text-center text-sm text-muted-foreground">
            {hasQuery ? "Không tìm thấy danh mục phù hợp." : "Chưa có danh mục nào."}
          </p>
        ) : (
          <ul role="tree" className="space-y-0.5">
            {visible.map((cat) => (
              <CategoryTreeNode
                key={cat.id}
                cat={cat}
                depth={0}
                selectedId={selectedId}
                onSelect={onSelect}
                forceExpanded={hasQuery}
              />
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
